export default {"src":"/_next/static/media/box.91744cd9.svg","height":400,"width":400};